// extracted by mini-css-extract-plugin
export var parcelRow = "_sp-0";